import styled from "styled-components";
export const SIZES = {
    PANEL_WIDTH: 300,
    PANEL_HEIGHT: 300
};
export default {
    Container: styled.div.attrs({
        className: "bg-modal border modal-padding with-gap-xs unselectable"
    }) `
    display: grid;
    grid-template-rows: auto auto 1fr auto;
    border-radius: 16px;
    overflow: hidden;
  `
};
